export default __webpack_public_path__ + "static/media/541.ecd87df9.png";